module.exports = __webpack_public_path__ + "static/img/SaveBackground.0f51342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personalInformation/SaveBackground.png
// module id = +V0I
// module chunks = 55